module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Db-Fb-Ge-Hc-Ia.c7e10279.png";